import { Pagination, PaginationProps } from "@mui/material";

type GaiaPaginationProps = Omit<PaginationProps, "page" | "count" | "onChange"> & {
    page: number;
    onPageChange: (page: number) => void;
    total: number;
    pageSize: number;
};

/*
    We need this wrapper because MUI pagination page prop does not start at 0 (like our api) but at 1.
*/
export default function GaiaPagination({ page, onPageChange, total, pageSize, ...muiProps }: GaiaPaginationProps) {
    const totalPages = total > 0 ? Math.ceil(total / pageSize) : 0;

    const muiPage = page + 1;
    const handleChange = (_event: unknown, muiPage: number) => {
        const newPage = muiPage - 1;
        onPageChange(newPage);
    };

    return <Pagination {...muiProps} page={muiPage} count={totalPages} onChange={handleChange} />;
}
